import React from 'react';
import { Bar, Line } from 'react-chartjs-2';
import { Paper, Typography } from '@mui/material';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

// Register required Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const ChartDisplay = ({ data }) => {
  // Build labels for each year up to serviceLife
  const years = Array.from({ length: data.serviceLife }, (_, i) => `Year ${i + 1}`);

  // Compute projected savings over time, accounting for degradation
  const savingsOverTime = years.map((_, i) => {
    const degradedFactor = Math.pow(1 - data.annualDegradation / 100, i);
    return (data.annualSavings * degradedFactor).toFixed(2);
  });

  // Cost breakdown: 75% material, 25% labor
  const materialShare = (data.totalApplicationCost * 0.75).toFixed(2);
  const laborShare = (data.totalApplicationCost * 0.25).toFixed(2);

  const barData = {
    labels: ['Material Cost', 'Labor Cost'],
    datasets: [
      {
        label: 'Cost Breakdown (₹)',
        data: [materialShare, laborShare],
        backgroundColor: ['rgba(33, 150, 243, 0.6)', 'rgba(76, 175, 80, 0.6)']
      }
    ]
  };

  const lineData = {
    labels: years,
    datasets: [
      {
        label: 'Projected Annual Savings (₹)',
        data: savingsOverTime,
        fill: false,
        borderWidth: 2
      }
    ]
  };

  return (
    <>
      <Paper sx={{ p: 2, mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          Cost Breakdown
        </Typography>
        <Bar data={barData} />
      </Paper>
      <Paper sx={{ p: 2, mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          Projected Savings Over Time
        </Typography>
        <Line data={lineData} />
      </Paper>
    </>
  );
};

export default ChartDisplay;
